var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDownDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5L6.16667 6.66668L5 7.83334L10 12.8333L15 7.83334L13.8333 6.66668L10 10.5Z",
    fill: "#212121"
  })));
}

export default __webpack_public_path__ + "media/a6f15f20.svg";
export { SvgArrowDownDefault as ReactComponent };